import { render, staticRenderFns } from "./SwapeRL.vue?vue&type=template&id=e60fdbfc&scoped=true"
import script from "./SwapeRL.vue?vue&type=script&lang=js"
export * from "./SwapeRL.vue?vue&type=script&lang=js"
import style0 from "./SwapeRL.vue?vue&type=style&index=0&id=e60fdbfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60fdbfc",
  null
  
)

export default component.exports